<template>
    <d-card-body>
        <d-col class="d-flex">
            <img class="img-fluid network-logo" :src="affiliate.logo">
        </d-col>
        <div class="row">
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-left">
                    <u>1. OAuth URL</u>
                </h6>
            </div>
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-right">
                    2. Complete
                </h6>
            </div>
        </div>
        <d-progress :value="percent" :max="100" />
        <d-row class="d-flex justify-content-center">
            <d-col md="12" class="mt-2">
                <p>In order to process transactions from {{ affiliate.human_readable_name }} you need to authenticate  via OAuth.</p>
            </d-col>
            <d-col lg="6" v-if="oauthUrl">
                <d-form id="networkForm">
                    <d-form-row>
                        <d-col md="12" class="form-group">
                            <a :href="oauthUrl" type="button" class="btn btn-success btn-sm">Connect via Daisycon</a>
                        </d-col>
                    </d-form-row>
                </d-form>
            </d-col>
        </d-row>
    </d-card-body>
</template>

<script>
    import { AffiliateNetworkService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        props: ['networkName', 'affiliate'],

        mixins: [notification],

        data() {
            return {
                postback: ' ',
                percent: 50,
                oauthUrl: null,
            }
        },

        methods: {
            close() {
                this.chooseRedirectPath()
                this.$router.go()
            },

            chooseRedirectPath() {
                if (this.$route.name === "connect") {
                    this.$router.push({ name: 'add-network', params: { id: this.$route.params.websiteId }})
                    return
                }
                if (this.$route.name === "connect-network") {
                    this.$router.push({ name: 'network', params: { id: this.$route.params.websiteId }})
                    return
                }
                this.$router.push({ path: `/network/${this.$route.params.websiteId}`})
            },

            async stepOne() {
                const response = await AffiliateNetworkService.generateDaisyconOauthUrl(
                    this.$route.params.websiteId,
                    this.$route.path
                )
                const parsedResponse = JSON.parse(response)

                if (Object.hasOwn(parsedResponse, 'uri')) {
                    this.oauthUrl = parsedResponse.uri
                }
            },

            async stepTwo() {
                const code = this.$route.query.code || '';
                const tokenText = await AffiliateNetworkService.receiveDaisyconOauthToken(code, this.$route.params.websiteId)

                if (tokenText === '') {
                    this.showNotification('error', 'Alert', 'Not found current domain in your media list!')
                    return;
                }
                const tokens = JSON.parse(tokenText);


                if (this.$route.params.accountId) {
                    await AffiliateNetworkService.update(
                        tokens,
                        this.$route.params.accountId,
                        'daisycon-oauth',
                        this.$route.params.networkId,
                        'EUR',
                        this.$route.params.websiteId,
                        '',
                        ''
                    )
                    this.showNotification('success', 'Alert', 'Network successfully edited!')
                } else {
                    await AffiliateNetworkService.create(
                        tokens,
                        this.$route.params.networkId,
                        this.networkName,
                        this.$route.params.websiteId,
                        'EUR',
                        '',
                        ''
                    )

                    this.showNotification('success', 'Alert', 'Network successfully connected!')
                }

                /*
                    * From domain page the customer clicks on the button Connect new network
                    * The customer gets send to the connect-network route
                    * The customer clicks on the button connect inside network card
                    * The customers fills in his credentials
                    * After successful connection the customers gets send to the connect-network route
                    */
                if (this.$route.name == 'connect-network') {
                    this.$router.push({ path: `/network/${this.$route.params.websiteId}`})
                }
                if (this.$route.name == 'network-update') {
                    this.$router.push({ path: `/network/${this.$route.params.websiteId}`})
                }

                /*
                * From add domain page the customer creates a new website
                * The customers gets send to step 2 add-network
                * The customer clicks on the button connect inside network card and gets send to the add-network/connect route
                * The customers fills in his credentials
                * After successful connection the customers gets send to the add-network route
                */
                if (this.$route.name == 'connect') {
                    this.$router.push({ path: `/add-network/${this.$route.params.websiteId}`})
                }
            },
        },

        async created() {
            if (Object.keys(this.$route.query).length) {
                await this.stepTwo()
            } else {
                await this.stepOne();
            }
        }
    }
</script>
